var kindOf = require('./kindOf');
    /**
     * Check if value is from a specific "kind".
     */
    function isKind(val, kind){
        return kindOf(val) === kind;
    }
    module.exports = isKind;




/*****************
 ** WEBPACK FOOTER
 ** ./~/mout/lang/isKind.js
 ** module id = 39
 ** module chunks = 0
 **/